<template>
<div>
    <client-accounting-form :getClientList="getClientList" :getClientAccountingList="getClientAccountingList" ref="clientAccountingFormModal"></client-accounting-form>
    <b-row>
        <b-col class="col-12">
            <div style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right;" size="sm" variant="outline-primary" @click="getInfo(0)">{{ $t('clientAccounting.add') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="clientAccountingTable" ref="clientAccountingTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'jurisdiction'" class="text-nowrap">
                {{ $t('clientAccounting.jurisdiction') }}
            </span>
            <span v-else-if="props.column.field === 'number'" class="text-nowrap">
                {{ $t('clientAccounting.account_number') }}
            </span>
            <span v-else-if="props.column.field === 'currency'" class="text-nowrap">
                {{ $t('clientAccounting.invoice_currency') }}
            </span>
            <span v-else-if="props.column.field === 'note'" class="text-nowrap">
                {{ $t('clientAccounting.note') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">

                        <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1" size="sm" @click="deleted(props.row)">
                        <feather-icon icon="XIcon" />
                    </b-button>
                </span>
            </span>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        clientId: Number,
        getClientList: {
            type: Function
        },
    },
    data() {
        return {
            pageLength: 10,
            dir: false,
            clientAccountingList: '',
            columns: [{
                    label: this.$t('clientAccounting.jurisdiction'),
                    field: `jurisdiction`,
                },
                {
                    label: this.$t('clientAccounting.account_number'),
                    field: `number`,
                },
                {
                    label: this.$t('clientAccounting.invoice_currency'),
                    field: `currency`,
                },
                {
                    label: this.$t('clientAccounting.note'),
                    field: `note`,
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        this.getClientAccountingList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'ClientAccounting'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getClientAccountingList()
                            if (this.getClientList != null)
                                this.getClientList()
                        } else if (response.data.resultStatus == false && response.data.resultMessage == 'ThisClientAccountingHaveInvoicesDeleteUnsuccessfull') {
                            this.$WarningAlert(this.$t('alerts.this_client_accounting_have_invoices_delete_unsuccessfull'))
                            this.getClientAccountingList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getClientAccountingList()
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.clientAccountingFormModal.showInfo(id, this.clientId)
        },
        getClientAccountingList() {
            this.rows = []
            const data = {
                id: this.clientId
            }
            const controller = {
                name: 'ClientAccounting',
                actionName: 'GetClientAccountingListByClientId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.clientAccountingList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
